import styled from 'styled-components';

export const StyledAsterisco = styled.span`
  &::after {
    content: '*';
    color: red;
  }
`;

export const ModalContainer = styled.div`
  padding-bottom: 10px;
  h2 {
    color: #096dd9;
    font-weight: 400;
    font-size: 20px;
  }
  h4 {
    padding: 15px 0 10px 0;
    font-weight: 600;
  }
  p {
    font-size: 14px;
    color: #8c8c8c;
  }
  .boxinputs {
    background-color: #fafafa;
    border: solid 1px #d9d9d9;
    padding: 1rem;
  }
`;

export const ItensAdicionados = styled.h4`
  font-size: 1.1rem;
  font-weight: 500;
  color: #545454;
`;
